import { DEFAULT_DOC_SECTION, isDocSection, type DocSectionId } from "./toc";

const docModules = import.meta.glob("./content/*/*.md", {
  query: "?raw",
  eager: true,
  import: "default",
}) as Record<string, string>;

const docsByLocale = {
  en: {} as Partial<Record<DocSectionId | "release-notes", string>>,
  tr: {} as Partial<Record<DocSectionId | "release-notes", string>>,
};

Object.entries(docModules).forEach(([path, content]) => {
  const match = path.match(/\/content\/(en|tr)\/([^/]+)\.md$/);
  if (!match) return;
  const locale = match[1] as "en" | "tr";
  const id = match[2];
  if (id === "release-notes" || isDocSection(id)) {
    docsByLocale[locale][id] = content;
  }
});

export function resolveDocsLocale(language: string): "en" | "tr" {
  return language.toLowerCase().startsWith("tr") ? "tr" : "en";
}

export function getDocMarkdown(section: string, language: string): string {
  const locale = resolveDocsLocale(language);
  const id: DocSectionId | "release-notes" = isDocSection(section)
    ? section
    : section === "release-notes"
      ? "release-notes"
      : DEFAULT_DOC_SECTION;
  return docsByLocale[locale][id] ?? docsByLocale.en[id] ?? "";
}
